import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import Text from '../../../shared/_TBComponents/Text';

import { ColorPrimary, ColorWhite } from '../../../shared/GlobalStyles';

import { setExerciseTab } from '../ducks/journalActions';

const TAB_TEXT_PROPS = {
  fontSize: '16px',
  color: ColorPrimary,
};

const ActiveBorderDiv = styled('div')`
  border-bottom: 1px solid ${ColorPrimary};
  width: 90%;
`;

const BoxContainer = styled('div')`
  align-items: center;
  display: flex;
  height: 100%;
`;

const EmptyBorderDiv = styled('div')`
  border-bottom-width: 1px;
`;

const InnerItemsContainer = styled('div')`
  display: flex;
`;

const TabBox = styled('button')`
  align-items: center;
  background-color: ${ColorWhite};
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  width: 33%;
`;

const TabSelectorDiv = styled('div')`
  background: ${ColorWhite};
  border: ${(props) => (props.isPrimaryDarkTheme ? `1px solid ${ColorWhite}` : '')};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  height: 40px;
  justify-content: space-between;
  margin-top: 10px;
  user-select: none;
`;

const ExerciseCategoryTabs = () => {
  const activeExerciseTab = useSelector((state) => state.journal.data.activeExerciseTab);
  const currentUser = useSelector((state) => state.auth.data.currentUser);

  const dispatch = useDispatch();

  const accountCode = currentUser?.accountCode;
  const isPrimaryDarkTheme = currentUser?.userSkin?.darkTheme || false;

  const handleTabClick = (tabType) => {
    dispatch(setExerciseTab(tabType, accountCode));
  };

  const renderTab = (tabType, label) => {
    const isActive = activeExerciseTab === tabType;

    return (
      <TabBox
        onClick={() => handleTabClick(tabType)}
        aria-label={label}
        aria-selected={isActive}
        role='tab'
      >
        <div />
        <InnerItemsContainer>
          <Text
            styledTextProps={TAB_TEXT_PROPS}
          >
            {label}
          </Text>
        </InnerItemsContainer>
        {isActive ? <ActiveBorderDiv /> : <EmptyBorderDiv />}
      </TabBox>
    );
  };

  return (
    <TabSelectorDiv isPrimaryDarkTheme={isPrimaryDarkTheme} role='tablist'>
      <BoxContainer>
        {renderTab('L', 'Lifts')}
        {renderTab('R', 'SAQ + C')}
        {renderTab('C', 'Circuits')}
      </BoxContainer>
    </TabSelectorDiv>
  );
};

export default ExerciseCategoryTabs;
